export const formatPercentOrDash = (value: number | null | undefined): string =>
  value === null || value === undefined ? '—' : `${Math.round(value)}%`;
